// @ts-nocheck
import React from "react";
import { RedireccionView } from "../Componentes/RedireccionView";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import useMediaQuery from '@mui/material/useMediaQuery';

export const ErrorFormulario = () => {
    const matches = useMediaQuery('(max-width:600px)');

    return (
        <RedireccionView
            href={window.location.origin + '/'}
            titulo={"Solicitud Vencida"}
            subtitulo={"El link correspondiente al formulario contiene una solicitud vencida, chequee su casilla de mail para la nueva solicitud"}
            icono={matches ? <ReportProblemIcon sx={{ fontSize: 40 }} /> : <ReportProblemIcon sx={{ fontSize: 60 }} />}
        />
    )
}